
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DatasetRepo, Dimension, FilterSchema, XcHelpResultPath, XcHelpResult, uuidv4, WEB_PATH_HOME, XcHelpResultPathPart, getBase64, openEditorWindowService } from '@gspwidget/util';
import { WidgetPropertyService } from '@gspwidget/widget-core';
import { DataField, PropertyOption, PropertyTypes } from '@gspwidget/widget-devkit';
import { TranslateService } from '@ngx-translate/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { FeFilterModalComponent } from '../../fe-filter-modal/fe-filter-modal.component';
import { HelpService } from '../../help/help.service';
import { XcHelpService } from '@gspwidget/util';
import { NumFormatModalComponent } from '../../num-format-modal/num-format-modal.component';
import { CEContext, PropertyChangeEvent, PropsAndValues } from '../../types';
import { UploadChangeParam } from 'ng-zorro-antd/upload';

@Component({
  selector: 'ce-item',
  templateUrl: './ce-item.component.html'
})
export class CeItemComponent implements OnInit {
  @Input() context: CEContext
  /**
   * 是否显示 label
   * 主要用于数组，不需要给数组项显示 label。
   */
  @Input() showLabel = true
  /** 无下边距。用于数组项里的 ce-item，无下边距。 */
  @Input() mb0 = false

  // 注意是否有的需要防抖、延迟触发 valueChange
  @Input() set propAndValue (v: { prop: PropertyOption, value: any }) {
    if (!v) return
    const { prop, value } = v
    if (prop === this.prop) return

    this.prop = prop
    this.value = value

    switch (prop.type) {
      case PropertyTypes.DataField:
        // 兼容 string 类型的老数据
        if (typeof value === 'string') {
          this.value = { name: value, label: value }
          this.handleChangeDataFieldValue(value)
        }
        break
      case PropertyTypes.Color:
        break
      case PropertyTypes.Object:
        this.objPropsAndValues = {
          props: Object.values(this.prop.objectOption.objPropertyOptions),
          propValues: value
        }
        break
      case PropertyTypes.Code:
      case PropertyTypes.Html:
      case PropertyTypes.Text:
      // case PropertyTypes.DataField:
        this.formControl = new FormControl(value, { updateOn: 'blur' })
        this.formControl.valueChanges.subscribe(this.handleChangeValue)
        break
      case PropertyTypes.Number:
        this.formControl = new FormControl(value)
        this.formControl.valueChanges.subscribe(this.handleChangeValue)
        break
      case PropertyTypes.SelectHelp:
        const { url, body } = prop.selectHelpOption
        if (prop.selectHelpOption.usePost) {
          this.http.post(url, body).subscribe(this.handleLoadedSelectHelpData)
        } else {
          this.http.get(url).subscribe(this.handleLoadedSelectHelpData)
        }
        this.formControl = new FormControl(value)
        this.formControl.valueChanges.subscribe(this.handleChangeValue)
        break
      case PropertyTypes.Bool:
      case PropertyTypes.Enum:
      default:
        this.formControl = new FormControl(value)
        this.formControl.valueChanges.subscribe(this.handleChangeValue)
    }
    if (prop.type === PropertyTypes.Bool) {
      this.id = uuidv4()
    }
  }
  /** 值变化事件 */
  @Output() onChangeValue = new EventEmitter()


  /** 当前 item 属性详情 */
  prop: PropertyOption
  /** 当前 item 的 value，用于渲染当前值 */
  value: any
  /** input, select */
  formControl: FormControl
  /** checkbox 需要 id 区分  */
  id: string
  /** Object */
  objPropsAndValues: PropsAndValues
  /** SelectHelp */
  selectHelpData: any[]
  /** Data Field */
  // dataFields = ['aa', 'bbb', 'cccc']
  /** color */
  colors: string[]
  /** dataField */
  // col: Col
  // numFormatSchema: NumFormatSchema = null

  readonly PropertyTypes = PropertyTypes

  /** Select Help 的数据加载完成 */
  handleLoadedSelectHelpData = (res: any[] | any) => {
    // this.formControl = new FormControl()
    // this.formControl.valueChanges.subscribe(this.handleChangeValue)

    if (Array.isArray(res)) this.selectHelpData = res
    if (Array.isArray(res.data)) this.selectHelpData = res.data

    // 保存结果、渲染
    // this.selectHelpData = res
    this.cd.detectChanges()
    // 取默认值，构造 formControl，注册变化回调
    // let isStringArray = typeof this.selectHelpData === 'string'
    // let initValue = this.value
    //   || this.prop.selectHelpOption.default
    //   || (isStringArray ? this.selectHelpData[0] : this.selectHelpData[0][this.prop.selectHelpOption.valueField])
    // this.formControl = new FormControl(initValue)
    // this.formControl.valueChanges.subscribe(this.handleChangeValue)
  }
  // all
  handleChangeValue = (newValue: any) => {
    this.value = newValue
    this.onChangeValue.emit(this.value)
  }

  constructor (
    private http: HttpClient,
    private cd: ChangeDetectorRef,
    private help: HelpService,
    public widgetProperty: WidgetPropertyService,
    private modal: NzModalService,
    private translate: TranslateService,
    private datasetRepo: DatasetRepo,
    private help2: XcHelpService,
  ) { }

  ngOnInit () {
    // TODO: 应该把这个 item 拆成一个个小的组件
    // if() debugger
    if (this.prop.type === PropertyTypes.Color) {
      this.colors = this.widgetProperty.getColorsByColorOption(this.prop.colorOption)
    }
  }

  // object
  handleChangeObjectValue (e: PropertyChangeEvent) {
    const { propName, value } = e
    this.value[propName] = value
    this.onChangeValue.emit(this.value)
  }

  // dataField
  oldPlainString: string
  /**
   * 点击 auto 会调用，输入框 blur 也会调用，所以注意尽量不重复发出同一个值。
   * data field 情况下，value 既可能是 name，也可能是 label，需要去 cols 中匹配出 dataField
   */
  handleChangeDataFieldValue (plainString: string) {
    if (this.oldPlainString === plainString) return
    this.oldPlainString = plainString
    const { cols } = this.context.extra
    if (cols) {
      // TODO: 逻辑有些过时了
      // 如果已有字段，手写就不起作用
      if (cols.length > 0) return
      const col = cols.find(c => c.name === plainString || c.label === plainString)
      if (col) { // 能匹配到 col，就用 col 的
        const { name, label } = col
        this.handleChangeValue({ name, label } as DataField)
      } else {
        this.handleChangeValue({ name: plainString, label: plainString } as DataField)
      }
    } else {
      this.handleChangeValue({ name: plainString, label: plainString } as DataField)
    }
  }
  handleSelectCol (colName: string) {
    if (!colName) {
      this.value = null
    } else {
      const { name, label } = this.findColInAggByName(colName);
      this.value = { name, label }
    }
    // (this.value as DataField).name = name;
    // (this.value as DataField).label = label
    // 把多语 label 存起来，wc 负责解析
    this.changeCol()
  }
  /**
   * 更新 dataField：先根据需要更新 this.col 或 this.numFormatSchema，
   * 再调此方法
   */
  changeCol () {
    // if (!this.col) return
    this.handleChangeValue({...this.value} as DataField)
  }
  getColShowLabel (name: string, i18nLabel: any | string) {
    if (!i18nLabel) return name
    if (typeof i18nLabel === 'string') return i18nLabel
    if (i18nLabel[this.translate.currentLang]) return i18nLabel[this.translate.currentLang]
    return name
  }
  private findColInAggByName (name: string): Dimension {
    if (!this.context.extra || !this.context.extra.cols) return
    return this.context.extra.cols
      .find(c => c.name === name || c.label === name)
  }

  /** 打开数据字段配置窗口 */
  handleClickDataFieldSetting () {
    const modalRef: NzModalRef<NumFormatModalComponent> = this.modal.create({
      nzTitle: this.translate.translations[this.translate.currentLang]['numericalFormat'],
      nzContent: NumFormatModalComponent,
      nzComponentParams: {
        schema: (this.value as DataField).numFormat
      },
      nzWidth: 600,
      nzClassName: 'body-p-vert-0',
      nzFooter: [{
        label: this.translate.translations[this.translate.currentLang]['cancel'],
        shape: 'default',
        onClick: () => modalRef.destroy()
      }, {
        label: this.translate.translations[this.translate.currentLang]['confirm'],
        type: 'primary',
        onClick: () => {
          (this.value as DataField).numFormat = modalRef.getContentComponent().schema
          this.changeCol()
          modalRef.destroy()
        }
      }]
    })
  }

  // help
  handleClickOpenHelp () {
    const { helpOption, displayName } = this.prop
    const { getData, structure, tableFields, valueField, nameField, getTableOnSelectTree } = helpOption
    this.help.show({
      title: this.translate.translations[this.translate.currentLang]['pleaseSelect'],
      structure,
      tableFields,
      nameField,
      getData: getData ? () => getData(this.http) : null,
      getTableOnSelectTree: getTableOnSelectTree ? (clickedNode) => getTableOnSelectTree(clickedNode, this.http) : null
    }).subscribe(item => {
      this.formControl.setValue(item[nameField])
      this.handleChangeValue({
        __type: 'help',
        value: item[valueField],
        name: item[nameField]
      })
    })
  }

  handleHelp2ValueChange (rawXcHelpResult: XcHelpResult<any>) {
    const { valueField, labelField, getResult } = this.prop.help2Option
    if (getResult) {
      getResult(rawXcHelpResult).then(({ value, label, path }) => {
        this.setHelp2ValueObject(value, label, path)
      })
    } else {
      Array.isArray(rawXcHelpResult.selected)
        ? this.setHelp2ValueObject(
          rawXcHelpResult.selected.map(item => item[valueField]),
          this.translate.instant('Selected'),
          rawXcHelpResult.path
        )
        : this.setHelp2ValueObject(
          rawXcHelpResult.selected[valueField],
          rawXcHelpResult.selected[labelField],
          rawXcHelpResult.path
        )
    }
  }

  setHelp2ValueObject (
    resultValue: string | string[],
    resultLabel: string | string[],
    xcHelpPath?: XcHelpResultPath,
  ) {
    this.value = {
      __type: 'help',
      value: resultValue,
      label: resultLabel,
      path: xcHelpPath,
      preset: this.prop.help2Option.preset,
    }
    this.handleChangeValue(this.value)
  }
  /**
   * 若非多选，则指定 label 为下方字符串
   * 若是多选，则不传入 label，用 help2 组件内置的 label
   * @returns
   */
  getHelp2Label () {
    if (!this.value) return
    const { value: helpValue, label: helpLabel } = this.value
    if (Array.isArray(helpValue)) return
    if (helpLabel && helpValue) {
      return `${helpLabel} ${'(' + helpValue + ')' }`
    } else if (helpLabel) {
      return helpLabel
    } else {
      return helpValue
    }
  }
  handleClickOpenFilter () {
    const modalRef: NzModalRef<FeFilterModalComponent> = this.modal.create({
      nzTitle: this.translate.translations[this.translate.currentLang]['filterConfig'],
      nzContent: FeFilterModalComponent,
      nzComponentParams: {
        fs: this.value || new FilterSchema()
      },
      nzWidth: '55%',
      nzClassName: 'body-p-vert-0',
      nzFooter: [{
        label: this.translate.translations[this.translate.currentLang]['cancel'],
        shape: 'default',
        onClick: () => modalRef.destroy()
      }, {
        label: this.translate.translations[this.translate.currentLang]['confirm'],
        type: 'primary',
        onClick: () => {
          const { fs: filterSchema } = modalRef.getContentComponent()
          // 此标记用于防止 wc 把 pvs 中的 i18n 字段处理成仅当前语言的字符串。
          // TODO: 是不是可以在筛选组件里处理，如果 i18nName 是字符串，则直接显示它？
          filterSchema.i18nName._notProcess = true
          this.handleChangeValue({ ...filterSchema })
          modalRef.destroy()
        }
      }]
    })
  }

  // scss
  handleBlurScss () {
    this.handleChangeValue(this.value)
  }

  editorWin: Window
  /**
   * windowName 必须有，否则无法同时开启多个窗口，比如需要同时开着 css 和 html 编辑器的时候
   * @param lang
   */
  handleOpenEditor (lang: string) {
    // 这样每次都会打开新窗口，不会有返回窗口不对问题了。但可能会开很多窗口。
    const winId = new Date().toString()
    // 窗口已经打开了就到前面来，现在没有窗口就重开一个
    const editorWin = this.editorWin
    if (editorWin && !editorWin.closed) {
      editorWin.focus()
    } else {
      this.editorWin = openEditorWindowService({
        xcWindowId: winId,
        xcInitialContent: this.value,
        xcLang: lang,
        xcOnConfirm: (value: string) => {
          this.value = value
          this.formControl.setValue(value)
          this.handleChangeValue(this.value)
          this.cd.detectChanges()
          if (window['cd']) window['cd'].detectChanges()
        }
      })
    }
  }
  ngOnDestroy () {
    if (this.editorWin) this.editorWin.close()
  }

  /********* img upload *********/
  // previewFileUrl
  imgInputType = 'upload'
  beforeUpload = (file: File) => {
    getBase64(file, (img: string) => {
      this.value = img
      this.handleChangeValue(this.value)
    })
    return false
  }
}
